<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Settings History</span><br/>
      <span style="font-style: italic; font-size: 18px">history of settings updates</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      &nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Filter Results&nbsp;<b-form-input style="width: 260px" v-model="text_filter" placeholder=""/>
    </div>

    <div v-if="!loading">
      <div class="row" style="margin: 30px 10px 30px 10px; font-weight: bold; font-size: 22px;">
        <div class="col" style="border: 1px solid grey;">Total: {{items_full.length}}</div>
        <div class="col" style="border: 1px solid grey;">Filtered: {{items.length}}</div>
      </div>
    </div>

    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
        </template>

        <template slot="diff" slot-scope="row">
          <pre style="text-align: left">{{row.item.diff}}</pre>
        </template>

      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import {get_booking_file_history, get_tenant_config_history} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment'
import {justDate} from "@/helpers/dates";

export default {
  name: 'tenant_config_history',
  components: {
  },

  data() {
    return {
      text_filter: '',
      items: [],
      items_full: [],
      summary: [],
      loading: true,
      details_fromDate: justDate(moment().add(-7, 'days')),
      details_toDate: justDate(moment()),
      booking_type: '',
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      fields_all: [],
      fields: [
        { key: 'processed_time', sortable: true},
        { key: 'updated_by', sortable: true},
        { key: 'diff', sortable: true},
      ]
      ,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(360, 'days'),
        maxDate: moment().add(0, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },

    }
  },

  async created() {
    this.fields_all = this.fields
    this.check_features()
  },
  methods: {
    async check_features() {
      this.load_data()
    },
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_tenant_config_history(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.records
        this.items_full = data.records
        this.filter_results()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    filter_results() {
      this.items = this.items_full
      if (this.text_filter != '') {
        const val = this.text_filter
        this.items = this.items.filter(item => (this.contains(JSON.stringify(item.diff), val)) || (this.contains(item.updated_by, val)))
      }
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    is_admin() {
      return this.user.role === 'admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    text_filter() {
      this.filter_results()
    }
  }
}
</script>

<style>
.error { background-color: rgba(255,0,0,0.25)}
.success { background-color: hsla(120,100%,75%,0.3)}
.unprocessed { background-color: hsla(200,40%,80%,0.3) }
.cancelled { background-color: hsla(290,60%,70%,0.3) }

.error td { background-color: rgba(255,0,0,0.25)}
.success td {background-color: hsla(120,100%,75%,0.3)}
.unprocessed td { background-color: hsla(200,40%,80%,0.3) }
.cancelled td { background-color: hsla(290,60%,70%,0.3) }


div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

recipients-list {
  white-space: break-spaces !important;
}

</style>

